import React from "react";
import { ArrayField, Datagrid, DateField, FunctionField, SelectField, useRecordContext } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { formatStudentOption } from "../../utils";
import AssignStudentsDialog from "./AssignStudentsDialog";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import DeleteStudentDialog from "./DeleteStudentDialog";

const StudentsInfo = ({ slotsChoices }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  return (
    <Grid
      item
      xs={12}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <ArrayField
        source="students"
        label="Назначени студенти"
      >
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
          sx={settings.style.secondaryDatagrid}
        >
          <FunctionField
            label="Име на студент"
            render={formatStudentOption()}
          />
          <SelectField
            source="startSlotId"
            label="Начален слот"
            choices={record?.slots}
            optionText={rec => `${rec.startTime} - ${rec.endTime}`}
          />

          <DateField
            source="assignedOn"
            label="Добавен на"
            locales="bg-BG"
          />
          <FunctionField
            render={rec => (
              <SecuredComponent permission={permissions.canManageInternshipSchedulesStudentsAssignments}>
                <DeleteStudentDialog
                  cycleId={record?.id}
                  studentEducationId={rec?.studentEducationId}
                />
              </SecuredComponent>
            )}
          />
        </Datagrid>
      </ArrayField>
      <SecuredComponent permission={permissions.canManageInternshipSchedulesStudentsAssignments}>
        <AssignStudentsDialog
          cycleId={record?.id}
          slotsChoices={slotsChoices}
          planId={record?.planId}
        />
      </SecuredComponent>
    </Grid>
  );
};

export default StudentsInfo;
